import React from 'react';
import PartnerNote from './PartnerNote';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'partner-note';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <PartnerNote
        key={`${type}-${index}`}
        note={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
